import React, { Component, Fragment } from 'react';
import styled from 'styled-components';
import {connect} from "react-redux";
import {deleteVurdering} from "../redux/actions/dataActions";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrashAlt } from '@fortawesome/free-solid-svg-icons';
import { Modal } from "react-bootstrap";



 

 class DeleteVurdering extends Component {
     state={
         open:false
     }

     handleOpen = () =>{
         this.setState({open:true})
     }
     handleClose = () =>{
        this.setState({open:false})
    }
    deleteVurdering = () =>{
        this.props.deleteVurdering(this.props.vurderingId);
        this.setState({open:false})
    }
    render() {
        return (
            <StyledDiv>
            <Fragment>
         <FontAwesomeIcon icon={faTrashAlt} onClick={this.handleOpen}  className="deleteButton" data-bs-toggle="tooltip" data-bs-placement="left" title="Slett"/>


<Modal className="modalOverlay d-flex align-items-center justify-content-center" show={this.state.open} >
<Modal.Header closeButton onClick={this.handleClose}>
            <Modal.Title> Slett vurdering </Modal.Title>
          </Modal.Header>
          <Modal.Body>
                    <div className="">
                    <p>Du er i ferd med å slette vurdering for godt</p>
<button className="btn btn-danger" onClick={this.deleteVurdering}>Slett</button>
                    </div>

          </Modal.Body>
        </Modal>

         </Fragment>
            </StyledDiv>
        )
    }
}


export default connect(null, {deleteVurdering})(DeleteVurdering)


const StyledDiv = styled.div`

.deleteButton{
    margin-left: 30px;
    color: red;
    cursor: pointer;
    z-index: 500;

    @media (max-width: 400px) {
        margin-left: 10px;
  }}
.deleteButton:hover{
 transition: all .2s ease-in-out; 
transform: scale(1.1); 
}

`
